// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { QueryFunctionContext, MutationFunction } from '@tanstack/react-query'
import { captureError } from './helpers'

type QueryKey = readonly unknown[]

type ErrorContext =
  | { type: 'query'; queryKey: QueryKey }
  | { type: 'mutation'; mutationKey: QueryKey }

export function withSentryOnError<TError = unknown>(
  context: ErrorContext,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userOnError?: (err: TError, ...args: any[]) => void
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (error: TError, ...rest: any[]) => {
    captureError(error, context)
    userOnError?.(error, ...rest)

    return false
  }
}
